<template>
  <section class="participation">
    <div class="participation__wrapper">
      <BaseTitle :text="titleText" class="participation__title  title" />
      <ParticipationList />
      <BaseBtn :text="btnText" :customClass="'default'" :to="'/terms'" />
    </div>
  </section>
</template>

<script>
import ParticipationList from '~/components/ParticipationList'

export default {
  name: 'ParticipationBlock',
  components: {
    ParticipationList
  },
  computed: {
    titleText() {
      return this.messages.index.participation.title
    },
    btnText() {
      return this.messages.index.participation.btnText
    }
  }
}
</script>

<style lang="scss">
.participation {
  position: relative;

  &::before {
    content: '';
    position: absolute;
    z-index: -2;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: url('~/static/img/participation-bg-shape@mb.svg') no-repeat
      center;
    background-size: contain;
  }

  &__wrapper {
    @include container;

    padding: 0 16px 0;
    text-align: center;
  }

  &__title {
    margin: 0 0 26px;
  }

  &__list {
    margin: 0 0 36px;
    padding: 0;
    list-style: none;
    counter-reset: list;
  }

  &__item {
    $items: (
      1: (
        width: 205px,
        height: 205px
      ),
      2: (
        width: 194px,
        height: 199px
      ),
      3: (
        width: 192px,
        height: 221px
      )
    );

    @include backgroundImage($items, 'participant-picture-', 'svg');

    &:not(:last-of-type) {
      margin-bottom: 37px;
    }

    &:nth-of-type(3) {
      &::after {
        top: -20px;
      }
    }
  }

  &__item-inner {
    position: relative;
    width: 205px;
    margin: 0 auto;
    padding-top: 230px;

    .animation-number {
      position: absolute;
      bottom: 20px;
      left: 0;

      &:nth-of-type(1) {
        img {
          width: 72px;
          height: 72px;
        }
      }

      &:nth-of-type(2) {
        img {
          width: 69px;
          height: 66px;
        }
      }

      &:nth-of-type(3) {
        img {
          width: 66px;
          height: 75px;
        }
      }
    }
  }

  .caption {
    margin: 0 0 7px;
  }

  .text {
    margin: 0;
  }
}

@include media-min($tablet-width) {
  .participation {
    &::before {
      background: url('~/static/img/participation-bg-shape@tl.svg') no-repeat
        center;
      background-size: 100% 577px;
    }

    &__wrapper {
      padding: 0 25px 100px;
    }

    &__title {
      margin-bottom: 55px;
    }

    &__list {
      display: flex;
      margin-bottom: 56px;
    }

    img {
      margin-bottom: 0;
    }

    &__item {
      flex-grow: 1;
      flex-basis: 25%;

      &::before {
        font-size: 24px;
        line-height: 45px;
      }

      &:not(:last-of-type) {
        margin: 0 20px 0 0;
      }
    }

    &__caption {
      margin: 0 0 20px;
    }
  }
}

@include media-min($desktop-width) {
  .participation {
    &::before {
      left: 50%;
      width: 1896px;
      height: 794px;
      background: url('~/static/img/participation-bg-shape@dt.svg') no-repeat
        center;
      background-size: cover;
      transform: translateX(-50%);
    }

    &__wrapper {
      padding: 0 60px 350px;
    }

    &__item {
      &:not(:last-of-type) {
        margin-right: 40px;
      }

      $items: (
        1: (
          width: 333px,
          height: 309px
        ),
        2: (
          width: 310px,
          height: 306px
        ),
        3: (
          width: 309px,
          height: 332px
        )
      );

      @include backgroundImage($items, 'participant-picture@dt-', 'svg');
    }

    &__item-inner {
      width: 320px;
      padding-top: 365px;

      .animation-number {
        position: absolute;
        bottom: 47px;
        left: 0;

        &:nth-of-type(1) {
          img {
            width: 119px;
            height: 93px;
          }
        }

        &:nth-of-type(2) {
          img {
            width: 123px;
            height: 93px;
          }
        }

        &:nth-of-type(3) {
          img {
            width: 119px;
            height: 93px;
          }
        }
      }
    }
  }
}

@include media-min($monoblock-width) {
  .participation {
    &::before {
      width: 3047px;
      height: 979px;
      background: url('~/static/img/participation-bg-shape@mn.svg') no-repeat
        center;
      background-size: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/ParticipationBlock.vue